export default "__VITE_ASSET__CIlfndLK__"